import styled from 'styled-components';

export default styled.div`
    .google-login-button {
        background-color: ${({ theme }) => theme.colors.google};
        width: 100%;
        color: #fff;
    }
`;
